import ClickAwayListener from '@mui/material/ClickAwayListener';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import PropTypes from 'prop-types';
import React, { useState, useEffect, useRef } from 'react';
import ChipsButton from 'react/member/components/dashboard/disbursements/filter_table/ChipsButton';
import TrueLinkButton from 'react/shared/components/true_link/main/TrueLinkButton';
import TrueLinkIcon from 'react/shared/components/true_link/main/TrueLinkIcon';
import TrueLinkLink from 'react/shared/components/true_link/main/TrueLinkLink';

export default function BooleanFilter({ column: { filterValue, setFilter, getFilterProps } }) {
  const filterProps = getFilterProps ? getFilterProps() : {};
  const { placeholder } = filterProps;
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState(filterValue || []);
  const containerRef = useRef(null);
  const showChips = selectedOptions.length > 0;

  useEffect(() => {
    setSelectedOptions(filterValue || []);
  }, [filterValue]);

  const handleOpenPopper = () => {
    setOpen((prev) => !prev);
    setPlacement('bottom');
  };

  const handleApply = () => {
    setFilter(selectedOptions && selectedOptions.length ? selectedOptions : undefined);
    setOpen(false);
  };

  const handleClear = () => {
    setFilter();
    setSelectedOptions([]);
  };

  const handleChange = (event) => {
    setSelectedOptions([event.target.value]);
  };

  const handleClickAway = () => {
    handleClear();
    setOpen(false);
  };

  const chips = selectedOptions.map((option) => ({
    label: option,
    onDelete: () => handleClear(),
  }));

  return (
    <>
      <div id="category-popper-container" ref={containerRef}>
        {showChips && !open ? (
          <ChipsButton chips={chips} onClick={handleOpenPopper} />
        ) : (
          <TrueLinkButton
            onClick={handleOpenPopper}
            size="small"
            style={{
              height: '42px',
              padding: '8px',
            }}
            variant="neutralOutline"
          >
            {placeholder || 'True/False'}
            <TrueLinkIcon icon="caret-down" style={{ marginLeft: '5px' }} />
          </TrueLinkButton>
        )}
      </div>
      <Popper
        anchorEl={containerRef.current}
        open={open}
        placement={placement}
        style={{ zIndex: 9999 }}
      >
        <ClickAwayListener onClickAway={handleClickAway}>
          <Paper
            style={{
              width: '200px',
              height: 'auto',
              padding: '15px',
            }}
          >
            <FormControl>
              <RadioGroup onChange={handleChange} value={selectedOptions?.[0] || ''}>
                <FormControlLabel control={<Radio />} label="Yes" value="Yes" />
                <FormControlLabel control={<Radio />} label="No" value="No" />
              </RadioGroup>
            </FormControl>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                margin: '10px',
              }}
            >
              <TrueLinkButton onClick={handleApply} size="small" variant="primary">
                Apply
              </TrueLinkButton>
              <TrueLinkLink onClick={handleClear} size="small" variant="error">
                Clear
              </TrueLinkLink>
            </div>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  );
}

BooleanFilter.defaultFilterFn = (rows, id, filterValue) => {
  if (filterValue === undefined || filterValue.length === 0) {
    return rows;
  }
  const convertedFilterValues = filterValue.map((value) => {
    switch (value) {
      case 'Yes':
        return true;
      case 'No':
        return false;
      default:
        return null;
    }
  });
  return rows.filter((row) => convertedFilterValues.includes(row.values[id]));
};

BooleanFilter.propTypes = {
  column: PropTypes.object.isRequired,
};
